"use client";
import * as React from "react";
import { HeaderProps } from "./types";
import { Button } from "./Button";
import { _ } from "@/lib/i18n";
import { Image } from "@/components/ui/image";

export const Header: React.FC<HeaderProps> = ({
  headerType,
  propertyId,
  headerName,
  hostId,
  hostName,
  headerImage,
  headerWebsite,
  propertyLocation,
}) => {
  return (
    <header id="Header" className="flex flex-row items-start w-full gap-[16px] md:gap-[24px]">
      <div className="flex flex-1 shrink gap-[8px] md:gap-[16px] items-start mr-auto text-sm md:text-md tracking-normal basis-0 min-w-60 max-sm:min-w-[120px]">
        <Image 
          className="object-cover shrink-0 self-stretch self-start my-auto aspect-[1/1] w-[40px] md:w-[44px] overflow-hidden"
          src={headerImage} 
          alt={`${headerName} property`}
          fallbackSrc="/assets/img/logo.png"
          fadeInDuration={400}
          rounded={true}
        />
        <div className="flex flex-col justify-center self-stretch my-auto gap-[3px]">
          <h1 className="font-semibold">
            {headerName}
          </h1>


          {/* Property header */}
          {headerType === "property" && (
            <p className="font-medium">
              <span className="text-tertiary">{_('hosted_by').toString()} </span>
              <span>
                <a href={`/${hostId}`} className="text-popover no-underline">{hostName}</a>
              </span>
            </p>
          )}

          {/* User profile header */}
          {headerType === "profile" && (
            <p>
              <span className="text-tertiary text-sm">@{hostId}</span>
            </p>
          )}

          {/* Property card - property header */}
          {headerType === "propertyCard" && (
            <p>
              <span className="text-tertiary text-sm">{propertyLocation}</span>
            </p>
          )}

        </div>
      </div>

      {/* BUTTONS */}
      <div id="headerButtons" className="flex gap-[8px] justify-center items-start text-center">

        {/* Header NOT in the Property card */}
        {headerType !== "propertyCard" && (
          headerWebsite && (
              <a href={headerWebsite} target="_blank" rel="noopener" aria-label="Property website">
                <button className="w-[24px] h-[24px] rounded-header-buttons p-[6px] bg-secondary">
                  <img src="/assets/img/buttonWebsiteLink.svg?placeholderIfAbsent=true" alt="" className="object-contain w-full h-full" />
                </button>
              </a>
            )
        )}
        
        {/* Property card - property header */}
        {headerType === "propertyCard" && (
            <Button
              key="propertyCard"
              buttonKey={123}
              type="function"
              button={_('open').toString()}
              onClick={() => window.open(`/${hostId}/property/${propertyId}`, "_self")}
              bgColor="bg-accent"
              buttonExtraClasses="md:text-sm px-[8px] !py-[6px] !h-[24px] !rounded-xs mt-[8px] mr-[8px] md:mt-[0px] md:mr-[0px]"
            />
        )}

          
          {/* <button className="w-6 h-6" aria-label="Share property">
          <img src="/assets/img/buttonShare.svg?placeholderIfAbsent=true" alt="" className="object-contain w-full h-full" />
        </button> */}
        {/* <button aria-label="Save property" className="px-2 py-1.5 rounded-lg border border-solid border-accent w-auto bg-accent">
          Save
        </button> */}
      </div>
    </header>
  );
};